import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingVisa, VISA_TYPE_LABEL } from "src/store/reducers/bookings";
import AddVisaBookingCanvas from "./AddVisaBookingCanvas";
import EditVisaBookingCanvas from "./EditVisaBookingCanvas";

interface ListBookingVisasProps {
  bookingId: string;
  bookingVisaData: BookingVisa[];
  setDeleteVisaId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
function ListBookingVisas({
  bookingId,
  bookingVisaData,
  setDeleteVisaId,
}: ListBookingVisasProps) {
  const [editVisaId, setEditVisaId] = useState<number>();
  const [showVisaAddModal, setShowVisaAddModal] = useState(false);
  const [show, setShow] = useState((bookingVisaData?.length ?? 0) > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Visas
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowVisaAddModal(true)}
                >
                  + Add Visa
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingVisaData?.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Visa Holder Name</th>
                            <th>Visa Number</th>
                            <th>Visa Type</th>
                            <th>Issuing Country</th>
                            <th>Validity Period</th>
                            <th>Fees</th>
                            <th>Advance Paid</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingVisaData?.map((visaData, index) => (
                            <tr key={visaData.id}>
                              <td>{visaData.visa_holder_name}</td>
                              <td>{visaData.visa_number}</td>
                              <td>
                                {VISA_TYPE_LABEL[visaData.visa_type]}
                              </td>
                              <td>{visaData.issuing_country}</td>
                              <td>{visaData.validity_period}</td>
                              <td>{visaData.fees}{visaData.currency ? ` ${visaData.currency}` : ""}</td>
                              <td>{visaData.advance_amount_paid || "-"}</td>
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditVisaId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeleteVisaId(visaData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add visas for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddVisaBookingCanvas
        Title={"Add Visa"}
        show={showVisaAddModal}
        bookingId={bookingId}
        setShow={setShowVisaAddModal}
      />
      <EditVisaBookingCanvas
        editId={
          typeof editVisaId !== "undefined"
            ? bookingVisaData?.[editVisaId]?.id
            : ""
        }
        Title={"Edit Visa"}
        bookingId={bookingId}
        data={
          typeof editVisaId !== "undefined"
            ? bookingVisaData?.[editVisaId]
            : undefined
        }
        hide={() => setEditVisaId(undefined)}
      />
    </>
  );
}

export default ListBookingVisas;
